import { z } from '../zod.js';

// Zod schema for MongoDB ObjectId string (strict validation for API parameters)
export const ObjectIdStringValidationSchema = z
  .string()
  .regex(/^[0-9a-fA-F]{24}$/, 'Invalid id format')
  .openapi('UniqueIdentifier', {
    description: 'Unique identifier. Must be in BSON ObjectId format.',
    example: '65f4a1c2e4a9f3d2b1c0a9e8',
  });
